import React from "react";
import ProjectItem from "./ProjectItem";
import Cocktail from "../../imgs/TheCocktailList.jpg";
import Memory from "../../imgs/MemoryGame.jpeg";
import PureTonyLogo from "../../imgs/logo2.jpg";
const ProjectList = () => {
  return (
    <div className="flex flex-col lg:pl-20 py-20 max-w-full h-full">
      <ProjectItem
        name={"PureTony - Full Stack ecommerce"}
        img={PureTonyLogo}
        desc={
          "A Full Stack ecommerce project with a beautiful homepage, shop, checkout, social logins and more."
        }
        gitlink="https://github.com/anargiris/pureTonyFront"
        demolink={"https://puretony-main.vercel.app/"}
        tech={["NextJS", "Strapi", "Tailwind", "MongoDB"]}
        alt="Full stack ecommerce project"
      />
      <ProjectItem
        name={"The Cocktail List"}
        img={Cocktail}
        desc={
          "A simple app that delivers a list of searched cocktails through an API. First app made using React Hooks."
        }
        gitlink="https://github.com/anargiris/TheCocktailApp"
        demolink={"https://thecocktaillist.netlify.app/"}
        tech={["React", "Tailwind"]}
        alt="Web app project displaying cocktails based on user search"
      />
      <ProjectItem
        name={"Memory Game (Desktop)"}
        img={Memory}
        desc={
          "A card-matching memory game with timer that uses a realtime leaderboard. Has some design experiments."
        }
        gitlink="https://github.com/anargiris/TheCocktailApp"
        demolink={"https://memorygamex.netlify.app/"}
        tech={["HTML", "CSS", "JavaScript", "Firebase"]}
        alt="mini-game project with live leaderboards"
      />
    </div>
  );
};

export default ProjectList;
